import React, { useState, useEffect } from "react";
import infoIMG from "../../SVG/InformacionmedicaCenfotec.svg";
import { useForm } from "react-hook-form";
import {
  obtenerSolicitudInfoMedica,
  agregarSolicitudInfoMedica,
} from "../../redux/solicitudesSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import OperationStatus from "../../config/OperationStatus";
import Required from "../../Components/Required";
import { getSolicitudPage } from "../../Api/content";
import { useLocale } from "../../i18n/localeContext";
import { Skeleton } from "antd";

import { useValidation } from "../../Hooks/useValidation";
export default function MedicalInfo(props) {
  const { validation } = useValidation();
  const dispatch = useDispatch();
  const { solicitudModel } = useSelector((state) => state.solicitudes);
  const { locale } = useLocale();
  const [solicitudPage, setSolicitudPage] = useState(null);
  const [isLoadingContent, setIsLoadingContent] = useState(true);
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({});
  const tieneEnfermedad = watch("tieneEnfermedad");

  useEffect(() => {
    dispatch(obtenerSolicitudInfoMedica(props.solicitudId));
  }, []);
  useEffect(() => {
    if (solicitudModel) {
      if (solicitudModel.infoMedicaModificado) {
        setValue("tieneEnfermedad", solicitudModel.tieneEnfermedad);
      }
      setValue("enfermedadNombre", solicitudModel.enfermedadNombre);
      setValue(
        "contactoEmergenciaNombre",
        solicitudModel.contactoEmergenciaNombre
      );
      setValue(
        "contactoEmergenciaTelefono",
        solicitudModel.contactoEmergenciaTelefono
      );
      setValue("medicamentos", solicitudModel.medicamentos);
      setValue("solicitudId", solicitudModel.solicitudId);
      setValue("etapaActual", solicitudModel.etapaActual);
    }
  }, [solicitudModel]);

  useEffect(() => {
    if (tieneEnfermedad != undefined || tieneEnfermedad != null) {
      let value = convertToBoolean(tieneEnfermedad);
      setValue("tieneEnfermedad", value);
    }
  }, [tieneEnfermedad]);

  const onSubmit = async (data) => {
    data.tieneEnfermedad = tieneEnfermedad;
    if (!tieneEnfermedad) {
      data.enfermedadNombre = "";
    }

    if (data.etapaActual === 3) data.etapaActual += 1;

    data.solicitudId = props.solicitudId;

    let { payload } = await dispatch(agregarSolicitudInfoMedica(data));
    if (payload.operationStatus === OperationStatus.SUCCESS) {
      toast.success(payload.message);
      props.onGoNext();
      props.handleStepChange(data.etapaActual);
    } else {
      toast.error(payload.message);
    }
  };
  const isRequired = (e) => {
    if (convertToBoolean(tieneEnfermedad)) return e.trim() != "";
    return true;
  };
  const isValid = (e) => {
    return typeof convertToBoolean(e) == "boolean";
  };

  const convertToBoolean = (myString) => {
    if (myString != undefined) {
      let myBool = myString.toString().toLowerCase() === "true";
      return myBool;
    }
  };

  useEffect(() => {
    let cancel = false;
    setIsLoadingContent(true);
    getSolicitudPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          setSolicitudPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => { 
        if (!cancel) {
          setSolicitudPage(null);
          setIsLoadingContent(false);
        }
      });
    return () => { cancel = true };
  }, [locale])

  if (isLoadingContent) {
    return (
      <form className="form-solicitud">
        <div className="form-c">
          <Skeleton active paragraph={{ rows: 4 }} />
          <Skeleton.Input style={{ width: '100%', height: 50 }} active />
          <Skeleton active paragraph={{ rows: 3 }} />
        </div>
      </form>
    );
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="form-solicitud">
      <div className="form-c">
        <div className="title-container">
          <span className="form-title">{solicitudPage?.medical_info.title || "Información médica"}</span>
        </div>
        <br />
        <div className="grid-container col-2 container">
          <div>
            <div className="grid-container col-2 col-lg-2">
              <div className="grid-item">
                <div className="form-group">
                  <label>{solicitudPage?.medical_info.question || "¿Padece de alguna enfermedad o alergia?"}</label>
                  <Required />
                  <div className="check-container">
                    <div className="form-control-check inline">
                      <input
                        type="radio"
                        {...register("tieneEnfermedad", { validate: isValid })}
                        value={true}
                        checked={tieneEnfermedad === true}
                      />
                      <label>{solicitudPage?.medical_info.optionY || "Si"}</label>
                    </div>
                    <div className="form-control-check inline">
                      <input
                        type="radio"
                        {...register("tieneEnfermedad", { validate: isValid })}
                        value={false}
                        checked={tieneEnfermedad === false}
                      />
                      <label>{solicitudPage?.medical_info.optionN || "No"}</label>
                    </div>
                    {tieneEnfermedad && (
                      <input
                        className="form-control"
                        id="inputAlergia"
                        placeholder="Especifique"
                        disabled={tieneEnfermedad != true}
                        type="text"
                        {...register("enfermedadNombre", {
                          validate: isRequired,
                        })}
                      />
                    )}
                  </div>
                  {errors.tieneEnfermedad?.type === "validate" && (
                    <p className="error">{validation?.required_field || "Campo requerido"}</p>
                  )}
                  {errors?.enfermedadNombre?.type === "validate" && (
                    <p className="error">{validation?.required_field || "Campo requerido"}</p>
                  )}
                </div>
              </div>
              <div className="grid-item">
                <div className="form-group">
                  <label>{solicitudPage?.medical_info.medicines || "Medicamentos que toma"}</label>
                  <input
                    className="form-control"
                    type="text"
                    {...register("medicamentos")}
                  />
                </div>
              </div>

              <div className="grid-item">
                <div className="form-group">
                  <label>{solicitudPage?.medical_info.emergencycontactname || "Nombre de contacto de emergencia"}</label>
                  <Required />
                  <input
                    className="form-control"
                    type="text"
                    {...register("contactoEmergenciaNombre", {
                      required: validation?.required_field || "Campo requerido",
                    })}
                  />
                  {errors.contactoEmergenciaNombre && (
                    <p className="error">
                      {errors.contactoEmergenciaNombre.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="grid-item">
                <div className="form-group">
                  <label>{solicitudPage?.medical_info.emergencycontactnumber || "Teléfono de contacto de emergencia"}</label>
                  <Required />
                  <input
                    className="form-control"
                    type="text"
                    {...register("contactoEmergenciaTelefono", {
                      required: validation?.required_field || "Campo requerido",
                    })}
                  />
                  {errors.contactoEmergenciaTelefono && (
                    <p className="error">
                      {errors.contactoEmergenciaTelefono.message}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="button-control">
            <img src={infoIMG} alt="ilustración Información médica" />
            <div>
              <button onClick={props.onGoBack}>{solicitudPage?.before_button || "Atrás"}</button>
              <button type="submit">{solicitudPage?.continue_button || "Continuar"}</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}
